import { useEffect, useState } from "react";

// components
import Toast, { IToastVariables, ToastMessageType } from "@/components/elements/global/ToastNotification";

const ToastWrapper = () => {

    const [showToast, setShowToast] = useState<boolean>(false)
    const [toastVariables, setToastVariables] = useState<IToastVariables>({message: undefined, messageType: ToastMessageType.SUCCESS});
    
    useEffect(() => {
        const ToastVariablesString = window.sessionStorage.getItem('toastOnLoad')

        if(ToastVariablesString) {
            const toastVariablesObject = JSON.parse(ToastVariablesString)
            if(toastVariablesObject.messageType && toastVariablesObject.message) {
                setToastVariables(toastVariablesObject);
                setShowToast(true);
            }
            window.sessionStorage.removeItem('toastOnLoad');
            
        }
    }, [])

    function handleToastMessageClose() {
        setShowToast(false);
        window.sessionStorage.removeItem('toastOnLoad');
    }

    return ( 
        <Toast
            show={showToast}
            closeToast={handleToastMessageClose} 
            messageType={toastVariables?.messageType}
        > 
            {toastVariables?.message}
        </Toast>
    )
}

export default ToastWrapper